<template>
    <span style="border-width: 1px;" :class="`vertical-middle rounded-full whitespace-nowrap px-3 p-1/2 text-xs ${border || 'border-[var(--primary-blue)]'} ${bg || 'bg-transparent'} ${fg || 'text-[var(--primary-blue)]'
        } align-text-bottom mb-1 `">
        {{ label }}
    </span>
</template>
<script lang="ts">
export default {
    props: {
        label: {
            type: String,
            required: true,
        },
        bg: String,
        fg: String,
        border: String,
    },
};
</script>